import { Consultant } from "./consultant";

export class AssignmentData {
    constructor(data: AssignmentData) {
        this.assignmentNumber = data.assignmentNumber;
        this.department = data.department;
        this.assignmentStartdate = data.assignmentStartdate;
        this.assignmentEndDate = data.assignmentEndDate;
        this.extendDate = data.extendDate;
        this.managerName = data.managerName;
        this.assignedConsultants = data.assignedConsultants;
        this.nrOfComments = data.nrOfComments;
        this.daysLeftToExtend = data.daysLeftToExtend;
        this.dispensation = data.dispensation;
        this.assignmentManager = data.assignmentManager;
    }
    assignmentNumber: string = ''; 
    department: string = '';
    assignmentStartdate: Date = new Date();
    assignmentEndDate: Date = new Date();
    extendDate: Date = new Date();
    managerName: string = '';
    assignedConsultants: Consultant[] = []; 
    nrOfComments: number = 0;
    daysLeftToExtend: number;
    dispensation: string;
    assignmentManager: string;
}
